// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Tunisia from '../_raw/flag/icon_flag_tunisia.png';

export default () => <img src={Tunisia} alt="Tunisia" />;
